import { createFeatureSelector, createSelector } from "@ngrx/store";
import { Dictionary } from "@ngrx/entity";
import {chatAdapter, ChatState, messageAdapter, participantAdapter} from "./chat.state";

export const selectChatState =
    createFeatureSelector<ChatState>('chats');


export const {
    selectAll: selectAllChats,
    selectEntities: selectChats,
} = chatAdapter.getSelectors(
    createSelector(selectChatState, s => s.chats)
);
export const {
    selectAll: selectAllMessages,
    selectEntities: selectMessages
} = messageAdapter.getSelectors(
    createSelector(selectChatState, s => s.messages)
);

export const {
    selectAll: selectAllParticipants,
    selectEntities: selectParticipants
} = participantAdapter.getSelectors(
    createSelector(selectChatState, s => s.participants)
);

export const selectChatById = (chatId: string) =>
    createSelector(selectChats, chats => chats[chatId]);

export const selectMessagesForChat = (chatId: string) =>
    createSelector(
        selectAllMessages,         // from message adapter
        messages =>
            messages
                .filter(m => m.chat_id === chatId)
                .slice()                    // avoid mutating original array
                .sort((a,b) => (new Date(a.created_at)).getTime() - (new Date(b.created_at)).getTime())
    );

export const selectParticipantsForChat = (chatId: string) =>
    createSelector(
        selectAllParticipants,         // from message adapter
        participants =>
            participants
                .filter(p => p.reference_id === chatId)
                .slice()                    // avoid mutating original array
    );

export const selectParticipantForUserInChat = (
    chatId: string,
    userId: string
) =>
    createSelector(
        selectAllParticipants,
        participants =>
            participants.find(
                p => p.reference_id === chatId && p.participant_id === userId
            )
    );



export const selectUnreadMessagesForChat = (
    chatId: string,
    userId: string
) =>
    createSelector(
        selectAllMessages,
        selectParticipantForUserInChat(chatId, userId),
        (messages, participant) => {
            if (!participant?.last_seen_at) {
                // If never read → everything is unread
                return messages.filter(m => m.chat_id === chatId);
            }

            const lastRead = new Date(participant.last_seen_at).getTime();

            return messages.filter(
                m =>
                    m.chat_id === chatId &&
                    new Date(m.created_at).getTime() > lastRead
            );
        }
    );

export const selectTotalUnreadMessagesForUser = (userId: string) =>
    createSelector(
        selectAllMessages,
        selectAllParticipants,
        (messages, participants) => {
            // Build a lookup: chatId -> lastReadTime for this user
            const lastReadByChat = new Map<string, number>();
            for (const p of participants) {
                if (p.participant_id === userId && p.last_seen_at) {
                    lastReadByChat.set(
                        p.reference_id,
                        new Date(p.last_seen_at).getTime()
                    );
                }
            }
            let unreadCount = 0;
            for (const m of messages) {
                const lastRead = lastReadByChat.get(m.chat_id);
                // If no participant record or no lastReadTime → unread
                if (!lastRead || new Date(m.created_at).getTime() > lastRead) {
                    unreadCount++;
                }
            }
            return unreadCount;
        }
    );


